import autoComplete from "@tarekraafat/autocomplete.js";

class MovieAutocomplete {
	constructor() {
		this.version = "10.2.9"; // autoComplete.js version
		this.request_url = "/ricerca/autocomplete/";
		this.input_name = "#search-field";
		this.current_search = "";
		this.results_id = "_search_result_list";
		this.category_filter_id = "_search-categories";
		this.close_button = "#close-search";
		this.loading = "#_search_loading";
	}

	init() {
		const autoCompleteJS = new autoComplete({
			selector: this.input_name,
			debounce: 500,
			threshold: 3,
			data: {
				src: async (query) => {
					this.current_search = query;
					let url = `${this.request_url}?term=${encodeURIComponent(query)}`;
					const cat_selected = localStorage.getItem("search_category");
					if (cat_selected) {
						url = `${url}&ct=${encodeURIComponent(cat_selected)}`;
					}
					try {
						const source = await fetch(url, {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
						});
						const data = await source.json();
						document.querySelector(this.loading).style.display = "none";
						return data;
					} catch (error) {
						return error;
					}
				},
				cache: false,
				keys: ["title"],
			},
			events: {
				input: {
					searchCategory: (event) => {
						const term = document.querySelector(this.input_name).value;
						autoCompleteJS.start(term);
					},
				},
			},
			resultsList: {
				element: (list, data) => {
					list.setAttribute("id", this.results_id);
					list.setAttribute("aria-label", "Search");
					list.setAttribute("tabindex", "-1");
					if (!data.results.length) {
						const result = document.createElement("li");
						result.setAttribute("class", "autoComplete_result");
						result.setAttribute("tabindex", "1");
						result.innerHTML = `
              <p class="p-3 m-0">Non ci sono risultati per "${this.current_search}"</p>
            `;
						list.appendChild(result);
					}
					this.appendAllResults();
					this.appendCategoryFilters();
				},
				destination: this.input_name,
				position: "afterend",
				tag: "ul",
				noResults: true,
				class: "autoComplete_list",
			},
			resultItem: {
				element: (element, data) => {
					const result = data.value;
					element.innerHTML = `
            <a class="media d-flex align-items-center p-2 gap-2" href="${result.link}">
              <div class="media-img flex-shrink-0">
                <img class="h-100 w-100" src="${result.image_lo}">
              </div>
              <div class="media-body flex-grow-1 d-flex flex-column align-items-start">
                <h5 class="mt-0 mb-1 fw-bold lh-1">${result.title}</h5>
                <p class="search-entry-labels m-0 mb-1 text-truncate d-inline lh-1">${result.category} | ${result.date}</p>
                <p class="search-entry-abstract m-0 lh-sm">${result.description}</p>
              </div>
            </a>`;
				},
				tag: "li",
				class: "autoComplete_result",
			},
		});
	}

	appendCategoryFilters() {
		if (!document.querySelector(`#${this.category_filter_id}`)) {
			const $results = document.querySelector(`#${this.results_id}`);
			const $categories = document.createElement("li");
			$categories.classList.add(
				"autoComplete_result_categories",
				"search-categories",
			);
			$categories.innerHTML = `
        <ul class="list-inline" id="${this.category_filter_id}">
          <li class="list-inline-item" id="_search-category-all" data-value="">Tutti</li>
          <li class="list-inline-item" data-value="film.film">Film</li>
          <li class="list-inline-item" data-value="serietv.serietv">Serie TV</li>
          <li class="list-inline-item" data-value="people.people">Personaggi</li>
          <li class="list-inline-item" data-value="tv.tvshow">Programmi TV</li>
          <li class="list-inline-item" data-value="article.article">Articoli</li>
        </ul>
      `;
			$results.insertBefore($categories, $results.firstChild);
			const cat_selected = localStorage.getItem("search_category");
			if (cat_selected) {
				document
					.querySelector(
						`#${this.category_filter_id} li[data-value="${cat_selected}"]`,
					)
					.classList.add("search-category-selected");
			} else {
				document
					.querySelector(`#${this.category_filter_id} li:first-child`)
					.classList.add("search-category-selected");
			}

			for (const el of document.querySelectorAll(
				`#${this.category_filter_id} li`,
			)) {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					this.resetSearchFilters();
					document.querySelector(this.loading).style.display = "flex";
					if (this.current_search) {
						localStorage.setItem("search_category", el.dataset.value);
						const customEvent = new Event("searchCategory");
						document.querySelector(this.input_name).dispatchEvent(customEvent);
					}
				});
			}
		}
	}

	appendAllResults() {
		if (!!document.querySelector(".autoComplete_result_all") === false) {
			const $results = document.querySelector(`#${this.results_id}`);
			const $all_results = document.createElement("li");
			$all_results.classList.add(
				"autoComplete_result_all",
				"pb-3",
				"pt-2",
				"px-3",
				"text-center",
				"text-md-end",
			);
			$all_results.innerHTML = `
        <a class="btn btn-sm w-auto py-1 px-3 btn-primary text-uppercase w-auto" href="/ricerca/?q=${encodeURIComponent(this.current_search)}">
          Vedi tutti i risultati
        </a>
      `;
			$results.appendChild($all_results);
		}
	}

	resetSearch() {
		this.resetSearchFilters();
		document.querySelector(this.input_name).value = "";
		this.current_search = "";
	}

	resetSearchFilters() {
		localStorage.removeItem("search_category");
	}
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const mainAutocomplete = new MovieAutocomplete();
	mainAutocomplete.init();

	// Search buttons
	// --------------------------------------------------
	document.querySelector("#btn-search").addEventListener("click", () => {
		document.querySelector(".search-form").style.visibility = "visible";
		document.querySelector(mainAutocomplete.input_name).focus();
		mainAutocomplete.resetSearch();
	});

	document
		.querySelector(mainAutocomplete.close_button)
		.addEventListener("click", () => {
			document.querySelector(".search-form").style.visibility = "hidden";
			mainAutocomplete.resetSearch();
		});

	document.querySelector("#submit-search").addEventListener("click", () => {
		const cat_selected = localStorage.getItem("search_category");
		if (cat_selected) {
			document.querySelector("#search-category").value = cat_selected;
			mainAutocomplete.resetSearchFilters();
		}
		document.querySelector("#search-form").submit();
	});
});
